import PropTypes from 'prop-types';
import PricePropType from './price';
import { FUEL_ID_TO_POI_VALUE, FUEL_TYPES } from '../constants';

export default PropTypes.shape({
  id: PropTypes.number.isRequired,
  displayName: PropTypes.oneOf(Object.values(FUEL_TYPES)).isRequired,
  fuelType: PropTypes.oneOf(Object.values(FUEL_ID_TO_POI_VALUE)).isRequired,
  prices: PropTypes.arrayOf(PricePropType).isRequired,
});
